
        import 'Table.a920f72.css-module'
        export default {"table":"table_Table_a920f72"}
    